import s from '../../sass/skeleton.scss';
import { Box, Cell, Layout, SkeletonLine } from '@wix/design-system';
import type { FC } from 'react';
import React from 'react';
import { SkeletonAppBox } from '../../components/skeletons/app-box-skeleton';

interface AppGridSkeletonProps {
  boxCount: number;
}

export function AppSectionSkeleton({ boxCount }: AppGridSkeletonProps) {
  const SkeletonSection: FC = () => {
    return (
      <>
        {Array.from({ length: boxCount }).map(() => (
          <Box width="280px" height="215px">
            <SkeletonAppBox />
          </Box>
        ))}
      </>
    );
  };

  return (
    <Box
      dataHook="skeleton-category-section"
      marginTop="36px"
      direction="vertical"
    >
      <Box direction="vertical">
        <Layout>
          <Cell span={10}>
            <SkeletonLine width="48px" />
          </Cell>
          <Cell span={2}>
            <Box align="right" paddingRight="52px">
              <SkeletonLine width="100px" />
            </Box>
          </Cell>
        </Layout>
      </Box>
      <Box
        dataHook="skeleton-apps"
        marginTop="12px"
        gap="24px"
        className={s.skeletonGrid}
      >
        <SkeletonSection />
      </Box>
    </Box>
  );
}
